import { useState } from 'react'
import {
  Required,
  UploadFileLabel,
  UploadFileName,
  UploadFileWrapper,
  ScanFilePreview,
  UploadPagination
} from './styles'
import { Upload } from 'antd'
import { RcFile } from 'antd/lib/upload/interface'
import Button from 'components/Button'
import { DownloadIcon } from 'components/Icons'
import { Field, FieldProps } from 'formik'
import { useTranslation } from 'react-i18next'
import Indication from 'components/Indication'
import { Document, Page, pdfjs } from 'react-pdf'
import { PDFDocumentProxy } from 'pdfjs-dist/types/src/display/api'

interface IProps {
  name: string,
  label?: string,
  required?: boolean,
  nbPerLine?: number,
  noBottomPadding?: boolean
}

const UploadFile = (props: IProps) => {
  const { name, label, required, nbPerLine, noBottomPadding } = props
  const { t } = useTranslation()
  const [file, setFile] = useState<RcFile>()
  const [scanFileBase64, setScanFileBase64] = useState<string>('')
  const [numPages, setNumPages] = useState(1)
  const [pageNumber, setPageNumber] = useState(1)

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const onDocumentLoadSuccess = (pdf: PDFDocumentProxy) => {
    setNumPages(pdf.numPages)
  }

  return (
    <Field name={name}>
      {(props: FieldProps) => {
        const hasError = !!props.form.errors[name]

        return (
          <UploadFileWrapper
            hasError={!!props.form.errors[name]}
            nbPerLine={nbPerLine || 0}
            noBottomPadding={noBottomPadding}
          >
            {label &&
              <UploadFileLabel>
                {required &&
                  <Required>* </Required>
                }

                {label}
              </UploadFileLabel>
            }
            { scanFileBase64 &&
            <ScanFilePreview>
              <Document file={scanFileBase64} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
              </Document>
              { numPages > 1 &&
                <UploadPagination >
                  {
                    pageNumber > 1 &&
                    <Button
                      size={'small'}
                      onClick={() => {
                        setPageNumber(pageNumber - 1)
                      }}
                    >
                      &#8592;
                    </Button>
                  }
                  <span>
                    {pageNumber} / {numPages}
                  </span>
                  { pageNumber < numPages &&
                    <Button
                      size={'small'}
                      onClick={() => {
                        setPageNumber(pageNumber + 1)
                      }}
                    >
                      &#8594;
                    </Button>
                  }
                </UploadPagination>
              }
            </ScanFilePreview>
            }
            <Upload
              accept="application/pdf"
              beforeUpload={(file) => {
                const reader = new FileReader()
                reader.onloadend = () => {
                  setScanFileBase64(reader.result as string)
                }
                reader.readAsDataURL(file)
                setFile(file)
                props.form.setFieldValue(name, file)

                if (file.size > 5000000) {
                  props.form.setFieldError(name, t('global.error.file-size', { weight: '5Mo' }))
                }
                return false
              }}
            >
              <UploadFileName>
                {file && file.name}
              </UploadFileName>

              <Button>
                <DownloadIcon />
              </Button>
            </Upload>
            {(props.form.errors[name]) &&
              <Indication
                hasError={hasError}
              >
                {props.form.errors[name]}
              </Indication>
            }
          </UploadFileWrapper>
        )
      }}
    </Field>
  )
}

export default UploadFile
